<script lang="ts" setup>
    enum variant {
        default = 'default',
        specification = 'specification'
    }

    const props = defineProps({
        filled: {
            type: Boolean,
            default: false
        },
        variant: {
            type: String,
            default: variant.default
        }
    })
</script>

<template>
    <span 
        v-if="props.variant === variant.specification"
        class="catalog_tag rounded-full py-0 px-2 leading-5 text-xs lowercase w-fit line-clamp-1"
        :class="filled ? 'text-white bg-primary-500' : 'border border-primary-500 text-primary-500'"
    >
        <slot />
    </span>
    <span 
        v-else
        class="catalog_tag rounded py-1.5 px-2 text-xs font-medium w-fit truncate"
        :class="filled ? 'bg-stroke' : 'border border-gray-200 text-gray-600'"
    >
        <slot />
    </span>
</template>